import { ROLE_HIERARCHY } from "../Constant/Roles";

class Utils{
    static userHasRequiredRole = (userRoles, requiredRoles) => {
        return requiredRoles?.some(requiredRole => 
          userRoles.some(userRole => ROLE_HIERARCHY[userRole]?.includes(requiredRole))
        );
      };

    static formatDateTimeUS = (date) =>
        new Date(date).toLocaleString('en-US', {
          month: '2-digit', day: '2-digit', year: 'numeric',
          hour: '2-digit', minute: '2-digit', hour12: true,
        });

    static formatDateUS = (date) =>
        new Date(date).toLocaleDateString('en-US', {
          month: '2-digit', day: '2-digit', year: 'numeric',
        });

    static formatDateTimeUSFullDate = (date) =>
        Utils.formatDateTimeUS(date);
      static UserListList = (userList, id) => {
        const filterList =
        userList?.length > 0 &&
        userList?.filter((data) => data?.value === id);
        if (filterList && filterList?.length > 0) {
          return filterList;
        } else {
          return userList;
        }
      };
}

export default Utils;